import React, { useEffect, useState } from "react";
import { DropdownButton, Dropdown, Button, Row, Col, ButtonGroup } from "@deere/ux.uxframe-react";
import { useSelector } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import { getSuppSurveyConfiguration } from "../../services/userService";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookie from "js-cookie";
import { uploadSurveyFile, handleSaveOS } from "../../utils/saveSurveyUtils";
import { savedSuccessFullySurvey } from "../../redux/action/saveAction";
import { useDispatch } from "react-redux";
import { useUserInfo } from "../../providers/userProvider";
import { LHR, SCBM_CODE, SCBM_INDIRECT, COC, OS_CONTACT_PARENT_ANS, OS_CONTACT_PARENT } from "../../utils/surveyLiterals";
import store from "../../redux/store";
import { updateGenResponse } from "../../redux/action/genericSurveyAction";
import "flag-icon-css/css/flag-icons.min.css";
import { getSurveyLanguages } from "../../utils/utils";

function getAnswers(survey, store) {
  let answers = store.getState().genericSurvey.surveyAnswersForm[survey.code];
  if (!answers) {
    answers = store.getState().survey.surveyAnswers;
  }
  return answers;
}

function getSurveyResponse(survey, store) {
  let surveyResponse = store.getState().genericSurvey.surveyResponses[survey.code];
  if (!surveyResponse) {
    surveyResponse = store.getState().survey.surveyResponse;
  }
  return surveyResponse;
}

const getOwnershipContacts = (survey, store, answers) => {
  let osContacts = store.getState().genericSurvey.osContactForm;
  let parentCheck = false;
  if (!osContacts) osContacts = [];
  let parentQue;
  for (let i = 0; i < survey.sections.length; i++) {
    let questions = survey.sections[i].questions;
    parentQue = questions.find((que) => que.code === OS_CONTACT_PARENT);
    if (parentQue) break;
  }
  if (parentQue) {
    let parentAns = answers.find((ans) => ans.questionId === parentQue.id);
    if (parentAns && parentAns.answer === OS_CONTACT_PARENT_ANS) {
      parentCheck = true;
    }
  }

  return { contacts: osContacts, parentCheck: parentCheck };
};

const OSButtonsSection = React.forwardRef(({ campaign, setSurvey, clearFunction, survey }) => {
  const { authState } = useOktaAuth();
  const campaignAssigned = useSelector((state) => state.campaign.campaignAssigned);
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [displayButton, setDisplayButton] = useState(false);
  const [currentLanguageCode, setCurrentLanguageCode] = useState(cookie.get("i18next") || "en");
  const LANGUAGES = getSurveyLanguages(survey.code);

  let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
  let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

  const changeLanguage = (locale) => {
    i18next.changeLanguage(locale);
    setCurrentLanguageCode(locale);
  };

  const handleSave = (e) => {
    e.preventDefault();
    clearFunction();
    let answers = getAnswers(survey, store);
    let surveyResponse = getSurveyResponse(survey, store);

    let ownershipData = getOwnershipContacts(survey, store, answers);
    handleSaveOS(surveyResponse, answers, campaign, userInfo, authState, ownershipData).then((responses) => {
      if (responses.length > 0) {
        const res = responses[responses.length - 1];
        if (res.id) {
          let i = 0;
          const selectElement = document.getElementsByClassName("surveyFile");
          for (let inputFile of selectElement) {
            i = i + 1;
            if (inputFile.value !== undefined && inputFile.value !== "") {
              const cert = inputFile.files[0];
              const fd = new FormData();
              fd.append("file", cert);
              fd.append("content-type", "application/pdf");

              uploadSurveyFile(fd, campaign, "file" + i, userInfo, authState.accessToken.accessToken)
                .then((response) => {})
                .catch((error) => {
                  console.log(error);
                });
            }
          }
          dispatch(updateGenResponse({ surveyCode: survey.code, surveyResponse: res }));
          res.variant = "success";
          res.description = t("lbl_success_save_message");
          dispatch(savedSuccessFullySurvey(res));
        }
      }
    });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getSuppSurveyConfiguration(campaignAssigned.surveyId, currentLanguageCode, token, isAuthMethodOkta).then((s) => {
      setSurvey(s);
      s.code === SCBM_CODE || s.code === SCBM_INDIRECT || s.code === LHR || s.code === COC ? setDisplayButton(true) : setDisplayButton(false);
    });
  }, [currentLanguageCode]);

  return (
    <Row className="card position-sticky fixed-bottom">
      <Row className="card position-sticky fixed-bottom">
        <Col md="24" className="card-body p-3 text-right">
          <ButtonGroup aria-label="Basic example">
            {displayButton && (
              <DropdownButton variant="secondary" className="mr-2" id="dropdown-basic" title={t("btn_change_language")} onClick={(e) => e.preventDefault()}>
                {LANGUAGES.map(({ code, name, country_code }) =>
                  currentLanguageCode === code ? (
                    <Dropdown.Item key={country_code} href="#" className="nav-link active" onClick={(e) => e.preventDefault()}>
                      <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 0.3 }}></span>
                      {name}
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item key={country_code} href="#" onClick={() => changeLanguage(code)}>
                      <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 1 }}></span>
                      {name}
                    </Dropdown.Item>
                  )
                )}
              </DropdownButton>
            )}
            <Button className="mr-2" variant="secondary" onClick={handleSave}>
              {t("btn_save_survey")}
            </Button>
            <Button className="mr-2" variant="primary" type="submit">
              {t("btn_review")}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Row>
  );
});

export default OSButtonsSection;
